// @ts-strict
import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { UserWebRequestHttpInterceptor } from '@app/http.intercepter';
import { HttpEvent } from '@angular/common/http';

@Injectable()
export class LMHttpIntercepterService {

  private serviceRequestHttpInterceptor!: UserWebRequestHttpInterceptor;
  private returnObservable: Observable<HttpEvent<any>> = new Observable<HttpEvent<any>>();

  private componentIndex = 0;
  private lmContext!: LMContext;
  constructor() {}

  public dataStream: ReplaySubject<any> = new ReplaySubject();

  public dataStream$(): Observable<any> {
    return this.dataStream.asObservable();
  }

  //  public dataStream$Observer: Subscriber<Array<LMToolbarButton>>;

  public run(data: any): any {
    const thing = this.dataStream.next(data);
    this.lmContext = data as LMContext;
  }

  public getUserWebRequestId() {
    const actorUniquId = this.lmContext.actorUniqueId;
    return actorUniquId + '-' + this.componentIndex++;
  }

  public registerItercepters(userWebRequestHttpInterceptor: UserWebRequestHttpInterceptor) {
    this.serviceRequestHttpInterceptor = userWebRequestHttpInterceptor;
  }
}
